import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/education")({
  head: () => ({
    meta: [
      { title: "Education Hub | Nkadimeng Danny Legal" },
      {
        name: "description",
        content:
          "AI-assisted legal education for South African learners — LLB tutoring, research tools, writing guides and downloadable study templates.",
      },
      { property: "og:title", content: "Education Hub — Nkadimeng Danny" },
      {
        property: "og:description",
        content:
          "LLB tutoring, legal research and writing tools for SA students.",
      },
      { property: "og:url", content: "https://nkadimengdannylcs.com/education" },
    ],
    links: [{ rel: "canonical", href: "https://nkadimengdannylcs.com/education" }],
  }),
  component: () => <Outlet />,
});
